import Stock from "../../../types/api/stock"

export default function calculateStockAmount(stock: Stock) {
    const totalReservedAmount =
        stock.stock_reserves?.reduce((sum, res) => sum + (res.amount || 0), 0) || 0
    return stock.amount - totalReservedAmount
}